export const FEATURE_TOUR_SEEN_KEY = 'featureTour';
